<template>
  <div>
    <span style="display: none">{{loadedScenario}}</span>
    <label class="label">Название сценария</label>
        <p class="control">
          <input v-model="scenario.name" class="input" type="text" placeholder="Введите название сценария">
        </p>
        <div>
          <div>
            <label class="label">Вопрос 1</label>
            <p class="control">
              <input type="radio" v-model="scenario.parameters.questionFirstGenerationState"
                     v-bind:value="false"
                     @change="onChangeGenerationStateStatic('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')">
              <label>Загрузить аудио</label>
              <br/>
              <input type="radio" v-model="scenario.parameters.questionFirstGenerationState"
                     v-bind:value="true"
                     @change="onChangeGenerationStateStatic('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')">
              <label>Сгенерировать аудио</label>
            </p>
            <div v-if="scenario.parameters.questionFirstGenerationState">
              <p class="control">
                <textarea v-model="scenario.parameters.questionFirstText" class="textarea"></textarea>
              <div class="control is-grouped">
                <button class="button is-primary" v-on:click="genAudioStatic('questionFirstId', 'questionFirstAudio', 'currentSpeakerFirst', 'questionFirstGeneratedAudio', 'questionFirstText', 'questionFirstLoading', 'First question', 'currentEmotionFirst', 'currentSpeedFirst')">
                  <span class="icon">
                    <i class="fa fa-magic"></i>
                  </span>
                  <div class="loader spinner" v-if="tmp.questionFirstLoading"></div>
                  Сгенерировать аудио
                </button>

                <div class="select is-primary">
                  <select v-model="tmp.currentSpeakerFirst" class="form-control">
                    <option v-for="speaker in speakerList">
                      {{speaker.value}}
                    </option>
                  </select>
                </div>
                <div class="select is-primary">
                  <select v-model="tmp.currentEmotionFirst" class="form-control">
                    <option v-for="emotion in emotionList">
                      {{emotion.value}}
                    </option>
                  </select>
                </div>
                <p>
                  <slider size="small" v-bind:value="tmp.currentSpeedFirst" :min="0.1" :step="0.1" :max="3" @change="tmp.currentSpeedFirst = $event"></slider>
                  Скорость:&nbsp{{tmp.currentSpeedFirst}}
                </p>

                <audio v-if="tmp.questionFirstGeneratedAudio" :ref="'onQuestionFirst'">
                  <source v-bind:src="scenario.parameters.questionFirstAudio">
                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                </audio>
                <audio-player v-if="tmp.questionFirstGeneratedAudio" :file="scenario.parameters.questionFirstAudio"/>
                <button v-if="scenario.parameters.questionFirstId!=''" class="button is-link delete-button" v-on:click="deleteAudioStatic('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'questionFirstGeneratedAudio')">
                  <span class="icon">
                    <i class="fa fa-minus-circle"></i>
                  </span>
                  <span>Удалить аудио</span>
                </button>
              </div>
              </p>
            </div>
            <div v-if="!scenario.parameters.questionFirstGenerationState">
              <p class="control">
              <div class="control">
                <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile('questionFirstLoadedAudio')">
                <input style="display:none;" @input="loadAudioStatic('questionFirstLoadedAudio', 'questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question', 'onQuestionFirst')" :id="`questionFirstLoadedAudio`" ref="questionFirstLoadedAudio" name="load-audio" type="file" accept=".wav,.mp3">
                <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question', true)">
                <audio v-if="tmp.questionFirstLoadedAudio" :ref="'onQuestionFirst'">
                  <source v-bind:src="scenario.parameters.questionFirstAudio">
                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                </audio>
                <audio-player v-if="tmp.questionFirstLoadedAudio" :file="scenario.parameters.questionFirstAudio"/>
                <button v-if="scenario.parameters.questionFirstId!=''" class="button is-link delete-button" v-on:click="deleteAudioStatic('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'questionFirstGeneratedAudio')">
                  <span class="icon">
                    <i class="fa fa-minus-circle"></i>
                  </span>
                  <span>Удалить аудио</span>
                </button>
              </div>
              </p>
            </div>
          </div>
        </div>
        <span class="second-layer positive-scenario add-button-wrapper">
          <label class="title">Опрос (При ответе Да на Вопрос 1)</label>
          <div v-for="(parameter, index) in scenario.parameters.dynamicQuestions" :key="parameter.key">

            <label v-if="scenario.parameters.dynamicQuestions.length!=index+1" class="label">Вопрос опроса {{index + 1}}</label>
            <label v-if="scenario.parameters.dynamicQuestions.length==index+1" class="label">Заключительное сообщение</label>

            <p class="control">
              <input type="radio" v-model="scenario.parameters.dynamicQuestions[index].generationState"
                     v-bind:value="false"
                     @change="onChangeGenerationState(parameter.generationState, index, parameter.key)">
              <label>Загрузить аудио</label>
              <br/>
              <input type="radio" v-model="scenario.parameters.dynamicQuestions[index].generationState"
                    v-bind:value="true"
                    @change="onChangeGenerationState(parameter.generationState, index, parameter.key)">
              <label>Сгенерировать аудио</label>
            </p>

            <div v-if="parameter.generationState">
              <p class="control">
              <textarea v-model="parameter.text" class="textarea"></textarea>
              <div class="control is-grouped">
                <button class="button is-primary" v-on:click="genAudio(index)">
                  <span class="icon">
                    <i class="fa fa-magic"></i>
                  </span>
                  <div class="loader spinner" v-if="tmp.dynamicTmp[index].dynamicLoading"></div>
                  Сгенерировать аудио
                </button>

                <div class="select is-primary">
                  <select v-model="tmp.dynamicTmp[index].dynamicSpeaker" class="form-control">
                    <option v-for="speaker in speakerList">
                      {{speaker.value}}
                    </option>
                  </select>
                </div>
                <div class="select is-primary">
                  <select v-model="tmp.dynamicTmp[index].dynamicEmotion" class="form-control">
                    <option v-for="emotion in emotionList">
                      {{emotion.value}}
                    </option>
                  </select>
                </div>
                <p>
                  <slider size="small" v-bind:value="tmp.dynamicTmp[index].dynamicSpeed" :min="0.1" :step="0.1" :max="3" @change="tmp.dynamicTmp[index].dynamicSpeed = $event"></slider>
                  Скорость:&nbsp{{tmp.dynamicTmp[index].dynamicSpeed}}
                </p>

                <audio v-if="tmp.dynamicTmp[index].dynamicGeneratedAudio" :ref="`audio-${parameter.key}`">
                <source v-bind:src="parameter.audio">
                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                </audio>
                <audio-player v-if="tmp.dynamicTmp[index].dynamicGeneratedAudio" :file="parameter.audio"/>
                <button v-if="index !== 0" class="button is-link delete-button" v-on:click="deleteParameter(index)">
                  <span class="icon">
                    <i class="fa fa-minus-circle"></i>
                  </span>
                  <span>Удалить</span>
                </button>
              </div>
              </p>
            </div>

            <div v-if="!parameter.generationState">
              <p class="control">
                <div class="control">
                  <input class="button is-info" type="button" value="Загрузить из файла" @click="clickLoadAudio(parameter.key)">
                  <input style="display:none;" @input="loadAudio(index, parameter.key)" :ref="`load-audio-${parameter.key}`" name="load-audio" type="file" accept=".wav,.mp3">
                  <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal(index, parameter.key, '', '', false)">
                  <audio v-if="tmp.dynamicTmp[index].dynamicLoadedAudio" :ref="`audio-${parameter.key}`">
                  <source v-bind:src="parameter.audio">
                    Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                  </audio>
                  <audio-player v-if="tmp.dynamicTmp[index].dynamicLoadedAudio" :file="parameter.audio"/>
                  <button v-if="index !== 0" class="button is-link delete-button" v-on:click="deleteParameter(index)">
                    <span class="icon">
                      <i class="fa fa-minus-circle"></i>
                    </span>
                    <span>Удалить</span>
                  </button>
                </div>
              </p>
            </div>

          </div>

          <div class="button-center">
            <button class="button is-primary is-outlined add-new" v-on:click="addNewParameter">+</button>
          </div>
        </span>


    <div>
          <span class="second-layer negative-scenario">
            <label class="title">При ответе Нет на Вопрос 1</label>
            <div>
              <label class="label">Вопрос 2 / Сообщение</label>
              <p class="control">
                <input type="radio" v-model="scenario.parameters.questionSecondGenerationState"
                       v-bind:value="false"
                       @change="onChangeGenerationStateStatic('questionSecondGenerationState', 'questionSecondAudio', 'questionSecondGeneratedAudio', 'questionSecondLoadedAudio', 'onQuestionSecond')">
                <label>Загрузить аудио</label>
                <br/>
                <input type="radio" v-model="scenario.parameters.questionSecondGenerationState"
                      v-bind:value="true"
                      @change="onChangeGenerationStateStatic('questionSecondGenerationState', 'questionSecondAudio', 'questionSecondGeneratedAudio', 'questionSecondLoadedAudio', 'onQuestionSecond')">
                <label>Сгенерировать аудио</label>
              </p>
              <div v-if="scenario.parameters.questionSecondGenerationState">
                <p class="control">
                <textarea v-model="scenario.parameters.questionSecondText" class="textarea"></textarea>
                <div class="control is-grouped">
                  <button class="button is-primary" v-on:click="genAudioStatic('questionSecondId', 'questionSecondAudio', 'currentSpeakerSecond', 'questionSecondGeneratedAudio', 'questionSecondText', 'questionSecondLoading', 'Second question', 'currentEmotionSecond', 'currentSpeedSecond')">
                    <span class="icon">
                      <i class="fa fa-magic"></i>
                    </span>
                    <div class="loader spinner" v-if="tmp.questionSecondLoading"></div>
                    Сгенерировать аудио
                  </button>

                  <div class="select is-primary">
                    <select v-model="tmp.currentSpeakerSecond" class="form-control">
                      <option v-for="speaker in speakerList">
                        {{speaker.value}}
                      </option>
                    </select>
                  </div>
                <div class="select is-primary">
                  <select v-model="tmp.currentEmotionSecond" class="form-control">
                    <option v-for="emotion in emotionList">
                      {{emotion.value}}
                    </option>
                  </select>
                </div>
                <p>
                  <slider size="small" v-bind:value="tmp.currentSpeedSecond" :min="0.1" :step="0.1" :max="3" @change="tmp.currentSpeedSecond = $event"></slider>
                  Скорость:&nbsp{{tmp.currentSpeedSecond}}
                </p>

                  <audio v-if="tmp.questionSecondGeneratedAudio" :ref="'onQuestionSecond'">
                    <source v-bind:src="scenario.parameters.questionSecondAudio">
                    Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                  </audio>
                  <audio-player v-if="tmp.questionSecondGeneratedAudio" :file="scenario.parameters.questionSecondAudio"/>
                  <button v-if="scenario.parameters.questionSecondId!=''" class="button is-link delete-button" v-on:click="deleteAudioStatic('questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'questionSecondGeneratedAudio')">
                    <span class="icon">
                      <i class="fa fa-minus-circle"></i>
                    </span>
                    <span>Удалить аудио</span>
                  </button>

                  </div>
                </p>
              </div>
              <div v-if="!scenario.parameters.questionSecondGenerationState">
                <p class="control">
                <div class="control">
                  <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile('questionSecondLoadedAudio')">
                  <input style="display:none;" @input="loadAudioStatic('questionSecondLoadedAudio', 'questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'Second question', 'onQuestionSecond')" :id="`questionSecondLoadedAudio`" name="load-audio" type="file" accept=".wav,.mp3">
                  <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal('questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'Second question', true)">
                  <audio v-if="tmp.questionSecondLoadedAudio" :ref="'onQuestionSecond'">
                    <source v-bind:src="scenario.parameters.questionSecondAudio">
                      Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                  </audio>
                  <audio-player v-if="tmp.questionSecondLoadedAudio" :file="scenario.parameters.questionSecondAudio"/>
                  <button v-if="scenario.parameters.questionSecondId!=''" class="button is-link delete-button" v-on:click="deleteAudioStatic('questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'questionSecondGeneratedAudio')">
                    <span class="icon">
                      <i class="fa fa-minus-circle"></i>
                    </span>
                    <span>Удалить аудио</span>
                  </button>
                </div>
                </p>
              </div>
            </div>

            <div class="block is-flex">
            <collapse>
              <collapse-item title="Сообщение при ответе Да на Вопрос 2" class="second-layer positive-scenario" :selected="scenario.parameters.questionSecondYesId!=''">
              <div>
              <p class="control">
                <input type="radio" v-model="scenario.parameters.questionSecondYesGenerationState"
                       v-bind:value="false"
                       @change="onChangeGenerationStateStatic('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')">
                <label>Загрузить аудио</label>
                <br/>
                <input type="radio" v-model="scenario.parameters.questionSecondYesGenerationState"
                        v-bind:value="true"
                        @change="onChangeGenerationStateStatic('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')">
                <label>Сгенерировать аудио</label>
              </p>
              <div v-if="scenario.parameters.questionSecondYesGenerationState">
                <p class="control">
                <textarea v-model="scenario.parameters.questionSecondYesText" class="textarea"></textarea>
                <div class="control is-grouped">
                  <button class="button is-primary" v-on:click="genAudioStatic('questionSecondYesId', 'questionSecondYesAudio', 'currentSpeakerSecondYes', 'questionSecondYesGeneratedAudio', 'questionSecondYesText', 'questionSecondYesLoading', 'Second yes question', 'currentEmotionSecondYes', 'currentSpeedSecondYes')">
                    <span class="icon">
                      <i class="fa fa-magic"></i>
                    </span>
                    <div class="loader spinner" v-if="tmp.questionSecondYesLoading"></div>
                    Сгенерировать аудио
                  </button>

                  <div class="select is-primary">
                    <select v-model="tmp.currentSpeakerSecondYes" class="form-control">
                      <option v-for="speaker in speakerList">
                        {{speaker.value}}
                      </option>
                    </select>
                  </div>
                  <div class="select is-primary">
                    <select v-model="tmp.currentEmotionSecondYes" class="form-control">
                      <option v-for="emotion in emotionList">
                        {{emotion.value}}
                      </option>
                    </select>
                  </div>
                  <p>
                    <slider size="small" v-bind:value="tmp.currentSpeedSecondYes" :min="0.1" :step="0.1" :max="3" @change="tmp.currentSpeedSecondYes = $event"></slider>
                    Скорость:&nbsp{{tmp.currentSpeedSecondYes}}
                  </p>

                  <audio v-if="tmp.questionSecondYesGeneratedAudio" :ref="'onQuestionSecondYes'">
                    <source v-bind:src="scenario.parameters.questionSecondYesAudio">
                    Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                  </audio>
                  <audio-player v-if="tmp.questionSecondYesGeneratedAudio" :file="scenario.parameters.questionSecondYesAudio"/>
                  <button v-if="scenario.parameters.questionSecondYesId!=''" class="button is-link delete-button" v-on:click="deleteAudioStatic('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'questionSecondYesGeneratedAudio')">
                    <span class="icon">
                      <i class="fa fa-minus-circle"></i>
                    </span>
                    <span>Удалить аудио</span>
                  </button>
                </div>
                </p>
              </div>
              <div v-if="!scenario.parameters.questionSecondYesGenerationState">
                <p class="control">
                <div class="control">
                <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile('questionSecondYesLoadedAudio')">
                <input style="display:none;" @input="loadAudioStatic('questionSecondYesLoadedAudio', 'questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question', 'onQuestionSecondYes')" :id="`questionSecondYesLoadedAudio`" name="load-audio" type="file" accept=".wav,.mp3">
                <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question', true)">
                <audio v-if="tmp.questionSecondYesLoadedAudio" :ref="'onQuestionSecondYes'">
                  <source v-bind:src="scenario.parameters.questionSecondYesAudio">
                 Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                </audio>
                <audio-player v-if="tmp.questionSecondYesLoadedAudio" :file="scenario.parameters.questionSecondYesAudio"/>
                <button v-if="scenario.parameters.questionSecondYesId!=''" class="button is-link delete-button" v-on:click="deleteAudioStatic('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'questionSecondYesGeneratedAudio')">
                  <span class="icon">
                    <i class="fa fa-minus-circle"></i>
                  </span>
                  <span>Удалить аудио</span>
                </button>
                </div>
                </p>
              </div>
              </div>
            </collapse-item>
              <collapse-item title="Сообщение при ответе Нет на Вопрос 2" class="second-layer negative-scenario" :selected="scenario.parameters.questionSecondNoId!=''">
              <div>
              <p class="control">
                <input type="radio" v-model="scenario.parameters.questionSecondNoGenerationState"
                       v-bind:value="false"
                       @change="onChangeGenerationStateStatic('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')">
                <label>Загрузить аудио</label>
                <br/>
                <input type="radio" v-model="scenario.parameters.questionSecondNoGenerationState"
                        v-bind:value="true"
                        @change="onChangeGenerationStateStatic('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')">
                <label>Сгенерировать аудио</label>
              </p>
              <div v-if="scenario.parameters.questionSecondNoGenerationState">
                <p class="control">
                <textarea v-model="scenario.parameters.questionSecondNoText" class="textarea"></textarea>
                <div class="control is-grouped">
                  <button class="button is-primary" v-on:click="genAudioStatic('questionSecondNoId', 'questionSecondNoAudio', 'currentSpeakerSecondNo', 'questionSecondNoGeneratedAudio', 'questionSecondNoText', 'questionSecondNoLoading', 'Second no question', 'currentEmotionSecondNo', 'currentSpeedSecondNo')">
                    <span class="icon">
                      <i class="fa fa-magic"></i>
                    </span>
                    <div class="loader spinner" v-if="tmp.questionSecondNoLoading"></div>
                    Сгенерировать аудио
                  </button>

                  <div class="select is-primary">
                    <select v-model="tmp.currentSpeakerSecondNo" class="form-control">
                      <option v-for="speaker in speakerList">
                        {{speaker.value}}
                      </option>
                    </select>
                  </div>
                  <div class="select is-primary">
                    <select v-model="tmp.currentEmotionSecondNo" class="form-control">
                      <option v-for="emotion in emotionList">
                        {{emotion.value}}
                      </option>
                    </select>
                  </div>
                  <p>
                    <slider size="small" v-bind:value="tmp.currentSpeedSecondNo" :min="0.1" :step="0.1" :max="3" @change="tmp.currentSpeedSecondNo = $event"></slider>
                    Скорость:&nbsp{{tmp.currentSpeedSecondNo}}
                  </p>

                  <audio v-if="tmp.questionSecondNoGeneratedAudio" :ref="'onQuestionSecondNo'">
                    <source v-bind:src="scenario.parameters.questionSecondNoAudio">
                    Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                  </audio>
                  <audio-player v-if="tmp.questionSecondNoGeneratedAudio" :file="scenario.parameters.questionSecondNoAudio"/>
                  <button v-if="scenario.parameters.questionSecondNoId!=''" class="button is-link delete-button" v-on:click="deleteAudioStatic('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'questionSecondNoGeneratedAudio')">
                    <span class="icon">
                      <i class="fa fa-minus-circle"></i>
                    </span>
                    <span>Удалить аудио</span>
                  </button>
                </div>
                </p>
              </div>
              <div v-if="!scenario.parameters.questionSecondNoGenerationState">
                <p class="control">
                <div class="control">
                <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile('questionSecondNoLoadedAudio')">
                <input style="display:none;" @input="loadAudioStatic('questionSecondNoLoadedAudio', 'questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question', 'onQuestionSecondNo')" :id="`questionSecondNoLoadedAudio`" name="load-audio" type="file" accept=".wav,.mp3">
                <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question', true)">
                <audio v-if="tmp.questionSecondNoLoadedAudio" :ref="'onQuestionSecondNo'">
                  <source v-bind:src="scenario.parameters.questionSecondNoAudio">
                 Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                </audio>
                <audio-player v-if="tmp.questionSecondNoLoadedAudio" :file="scenario.parameters.questionSecondNoAudio"/>
                <button v-if="scenario.parameters.questionSecondNoId!=''" class="button is-link delete-button" v-on:click="deleteAudioStatic('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'questionSecondNoGeneratedAudio')">
                  <span class="icon">
                    <i class="fa fa-minus-circle"></i>
                  </span>
                  <span>Удалить аудио</span>
                </button>
                </div>
                </p>
              </div>
              </div>
            </collapse-item>
            </collapse>
            </div>
          </span>
    </div>
        <hr>
        <p class="control">
          <button class="button is-primary" v-on:click="save(true)">
            <span class="icon">
              <i class="fa fa-floppy-o"></i>
            </span>
            <span>Сохранить</span>
          </button>
          <button class="button is-light" v-on:click="cancel">
            <span class="icon">
              <i class="fa fa-times-circle"></i>
            </span>
            <span>Закрыть</span>
          </button>
          <button class="button is-primary">
        <span class="icon">
          <i class="fa fa-calculator"></i>
        </span>
            <span>Рассчитать стоимость</span>
          </button>
          <button v-if="scenario.isReady" class="button is-success is-outlined" :disabled="true">
        <span class="icon">
          <i class="fa fa-info"></i>
        </span>
            <span>Подготовлен</span>
          </button>
          <button v-else class="button is-danger is-outlined" :disabled="true">
        <span class="icon">
          <i class="fa fa-info"></i>
        </span>
            <span>Не подготовлен</span>
          </button>
        </p>
    <modal :visible="showModal" :title=title @confirm="confirmAction" @close="closeModal"></modal>
  </div>
</template>

<script>
  import Cleave from 'vue-cleave'
  import AudioPlayer from '../../../components/audio-player.vue'
  import { mapGetters } from 'vuex'
  import Vue from 'vue'
  import Notification from 'vue-bulma-notification'
  import { Collapse, Item as CollapseItem } from 'vue-bulma-collapse'
  import Message from 'vue-bulma-message'
  import Modal from '../ModalAudio'
  import Slider from 'vue-bulma-slider'

  const NotificationComponent = Vue.extend(Notification)
  const openNotification = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  }) => {
    return new NotificationComponent({
      el: document.createElement('div'),
      propsData
    })
  }

  const MessageComponent = Vue.extend(Message)
  const openMessage = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  }) => {
    return new MessageComponent({
      el: document.createElement('div'),
      propsData
    })
  }

  const api = '/api/scenarios'
  const audioGeneratorApi = '/audios/generate'
  const audioUploadApi = '/audios/save'
  const audioDeleteApi = '/audios'
  const PROFILES_API = '/api/profiles'

  export default {
    props: ['name', 'campaignid'],
    components: {
      Modal,
      Cleave,
      AudioPlayer,
      Message,
      Notification,
      Collapse,
      CollapseItem,
      Slider
    },
    computed: {
      ...mapGetters([
        'loadedScenario',
        'loggedId',
        'loggedUser',
        'authenticationToken'
      ])
    },
    methods: {
      prepareSecurityHeader() {
        console.log(this.authenticationToken)
        return {
          Authorization: `Bearer ${this.authenticationToken}`
        }
      },
      addNewParameter () {
        this.scenario.parameters.dynamicQuestions.push({ generationState: true, text: '', audio: '', id: undefined, key: Math.floor(Math.random() * 99999999) + 1 })
        this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: '', dynamicLoadedAudio: '', dynamicLoading: false, dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 })
      },
      deleteParameter (i) {
        this.scenario.parameters.dynamicQuestions.splice(i, 1)
        this.tmp.dynamicTmp.splice(i, 1)
      },
      changeRoute: function(e) {
        this.$router.push({path:'/scenarios' + e.target.value})
      },
      checkAudioDuration() {
        this.scenario.checkDuration = true
        var len = document.querySelectorAll('audio').length
        for (var i = 0; i < len; i++) {
          if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
            this.scenario.checkDuration = this.scenario.checkDuration && (document.querySelectorAll('audio')[i].duration > 0)
          }
        }
        return this.scenario.checkDuration
      },
      save (showMessage) {
        if (this.checkAudioDuration()) {
          if (this.scenario.id === undefined) {
            this.saveNew(showMessage)
          } else {
            this.update(showMessage)
          }
        } else {
          this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности')
        }
      },
      saveNew (showMessage) {
        console.log('saving new scenario: ' + JSON.stringify(this.scenario))
        if (!this.scenario.parameters.questionFirstGenerationState) {
          this.scenario.parameters.questionFirstText = ''
        }
        if (!this.scenario.parameters.questionSecondGenerationState) {
          this.scenario.parameters.questionSecondText = ''
        }
        if (!this.scenario.parameters.questionSecondYesGenerationState) {
          this.scenario.parameters.questionSecondYesText = ''
        }
        if (!this.scenario.parameters.questionSecondNoGenerationState) {
          this.scenario.parameters.questionSecondNoText = ''
        }
        this.scenario.parameters.dynamicQuestions.forEach(function (dynamicQuestion) {
          if (!dynamicQuestion.generationState) {
            dynamicQuestion.text = ''
          }
        })
        this.scenario.parameters.questionSecondYesOptional = true
        this.scenario.parameters.questionSecondNoOptional = true
        this.$http.post(api, this.scenario, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.isSaved = true
            if (showMessage) {
              this.openNotificationWithType('info', 'Сценарий сохранен')
              this.$emit('set', this.scenario)
            }
            this.scenario = response.data
          }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ')
        })
      },
      update (showMessage) {
        this.scenario.parameters.questionSecondYesOptional = true
        this.scenario.parameters.questionSecondNoOptional = true
        console.log('updating scenario: ' + JSON.stringify(this.scenario))
        this.$http.put(api, this.scenario, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.isSaved = true
            this.scenario = response.data
            if (showMessage) {
              this.openNotificationWithType('info', 'Сценарий сохранен')
            }
          }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ')
        })
      },
      uploadFile(buttonId) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий')
        } else {
          document.getElementById(buttonId).click()
        }
      },
      genAudioRequest (maybeId, audioName, text, speaker, emotion, speed) {
        var request = {
          'client': this.scenario.client,
          'scenario': this.scenario.id,
          'audioName': audioName,
          'generator': 'yandex',
          'text': text,
          'parameters': {
            'speaker': speaker,
            'emotion': emotion,
            'speed': speed,
            'text': text
          }
        }
        // if audio already generated, request must contain id, so backend will overwrite existing audio
        if (maybeId) {
          request.id = maybeId
        }
        return request
      },
      securityHeaders () {
        return {'testH': 'testHV', 'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ'}
      },
      onChangeGenerationState(state, index, key) {
        const parameter = this.scenario.parameters.dynamicQuestions[index]
        if (state) {
          parameter.audio = this.tmp.dynamicTmp[index].dynamicGeneratedAudio
          this.$refs[`audio-${key}`][0].load()
        } else {
          parameter.audio = this.tmp.dynamicTmp[index].dynamicLoadedAudio
          this.$refs[`audio-${key}`][0].load()
        }
      },

      loadAudio(index, key) {
        const input = this.$refs['load-audio-' + key][0]
        if (input.files && input.files[0]) {
          if (!this.isSaved) {
            this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий')
          } else {
            this.handleUploadRequest(index, key, input.files[0])
          }
        }
      },
      handleUploadRequest (index, key, audioFile) {
        this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile), this.prepareUploadHeaders())
          .then(response => {
            this.setAudioValue(index, key, response)
          })
          .catch(error => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки аудио. ')
          })
      },
      deleteAudio(index) {
        this.$http.delete(`${audioDeleteApi}/${this.scenario.parameters.dynamicQuestions[index].id}`, {headers: this.prepareUploadHeaders()})
          .then((response) => {
            this.deleteAudioValue(index)
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка удаления аудио. ')
          })
      },
      setAudioValue (index, key, response) {
        this.scenario.parameters.dynamicQuestions[index].id = response.data
        this.tmp.dynamicTmp[index].dynamicLoadedAudio = `/audios/${response.data}.wav`
        this.scenario.parameters.dynamicQuestions[index].audio = this.tmp.dynamicTmp[index].dynamicLoadedAudio
        this.$refs[`audio-${key}`][0].load()
      },
      deleteAudioValue (index) {
        this.scenario.parameters.dynamicQuestions[index].id = ''
        this.tmp.dynamicTmp[index].dynamicLoadedAudio = ''
        this.tmp.dynamicTmp[index].dynamicGeneratedAudio = ''
        this.scenario.parameters.dynamicQuestions[index].audio = ''
      },
      genAudio(index) {
        const parameter = this.scenario.parameters.dynamicQuestions[index]
        let {text, id} = parameter
        const requestData = this.genAudioRequest(id, `audioname${index + 1}`, text, this.tmp.dynamicTmp[index].dynamicSpeaker, this.tmp.dynamicTmp[index].dynamicEmotion, this.tmp.dynamicTmp[index].dynamicSpeed)
        const config = {headers: this.securityHeaders()}
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий')
        } else {
          this.tmp.dynamicTmp[index].dynamicLoading = true
          this.$http.post(audioGeneratorApi, requestData, config)
            .then((response) => {
              this.handleGenRequest(parameter, index, response.data)
              this.tmp.dynamicTmp[index].dynamicLoading = false
              this.$refs[`audio-${parameter.key}`][0].load()
            })
            .catch((error) => {
              console.log(error)
              this.openNotificationWithType('danger', 'Ошибка загрузки аудио. ')
              this.tmp.dynamicTmp[index].dynamicLoading = false
            })
        }
      },
      handleGenRequest (parameter, index, data) {
        parameter.id = data
        this.tmp.dynamicTmp[index].dynamicGeneratedAudio = '/audios/' + data + '.wav'
        parameter.audio = this.tmp.dynamicTmp[index].dynamicGeneratedAudio
      },
      onChangeGenerationStateStatic(stateId, audioId, generatedAudioId, loadedAudioId, playerId) {
        if (this.scenario.parameters[stateId]) {
          this.scenario.parameters[audioId] = this.tmp[generatedAudioId]
          this.$refs[playerId][0].load()
        } else {
          this.scenario.parameters[audioId] = this.tmp[loadedAudioId]
          this.$refs[playerId][0].load()
        }
      },
      genAudioStatic(id, audio, speaker, generatedAudio, text, loadingStatus, name, emotion, speed) {
        const request = this.genAudioRequest(this.scenario.parameters[id], name, this.scenario.parameters[text], this.tmp[speaker], this.tmp[emotion], this.tmp[speed])
        const headers = {headers: this.securityHeaders()}
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий')
        } else {
          this.tmp[loadingStatus] = true
          this.$http.post(audioGeneratorApi, request, headers)
            .then(response => {
              this.handleGenRequestStatic(id, audio, generatedAudio, response.data)
              this.tmp[loadingStatus] = false
            })
            .catch(error => {
              console.log(error)
              this.openNotificationWithType('danger', 'Ошибка загрузки аудио. ')
              this.tmp[loadingStatus] = false
            })
        }
      },
      handleGenRequestStatic (id, audio, generatedAudio, data) {
        this.scenario.parameters[id] = data
        this.tmp[generatedAudio] = `/audios/${data}.wav`
        this.scenario.parameters[audio] = this.tmp[generatedAudio]
      },
      loadAudioStatic(inputId, audioId, audioValue, generationType, audioName, player) {
        const input = document.querySelector(`#${inputId}`)
        if (input.files && input.files[0]) {
          if (!this.isSaved) {
            this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий')
          } else {
            this.handleUploadRequestStatic(audioId, audioValue, generationType, input.files[0], audioName)
            this.$refs[player].load()
          }
        }
      },
      handleUploadRequestStatic (audioId, audioValue, generationType, audioFile, audioName) {
        this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile, audioName, this.scenario.client, this.scenario.id), this.prepareUploadHeaders())
          .then(response => {
            this.setAudioValueStatic(audioId, generationType, audioValue, response)
          })
          .catch(error => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки аудио. ')
          })
      },
      deleteAudioStatic(audioId, audioValue, generationType1, generationType2) {
        this.$http.delete(`${audioDeleteApi}/${this.scenario.parameters[audioId]}`, {headers: this.prepareUploadHeaders()})
          .then((response) => {
            this.deleteAudioValueStatic(audioId, generationType1, generationType2, audioValue)
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка удаления аудио. ')
          })
      },
      prepareMultipartAudio (audioFile, audioName, audioClient, audioScenario) {
        const audioFormData = new FormData()
        audioFormData.append('file', audioFile)
        audioFormData.append('name', audioName)
        audioFormData.append('client', audioClient)
        audioFormData.append('scenario', audioScenario)
        return audioFormData
      },
      prepareUploadHeaders () {
        return {
          'headers': {
            'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
            'Content-Type': 'multipart/form-data',
            'testH': 'testHV'
          }
        }
      },
      setAudioValueStatic (audioId, generationType, audioValue, response) {
        this.scenario.parameters[audioId] = response.data
        this.tmp[generationType] = `/audios/${this.scenario.parameters[audioId]}.wav`
        this.scenario.parameters[audioValue] = this.tmp[generationType]
      },
      deleteAudioValueStatic (audioId, generationType1, generationType2, audioValue) {
        this.scenario.parameters[audioId] = ''
        this.tmp[generationType1] = ''
        this.tmp[generationType2] = ''
        this.scenario.parameters[audioValue] = ''
      },
      load () {
        this.$http({
          url: api + '/' + this.name,
          headers: this.prepareSecurityHeader()
        }).then((response) => {
          console.log('opening scenario ' + JSON.stringify(response.data))
          this.isSaved = true
          this.scenario = response.data
          this.question_first_audio = '/audios/' + this.scenario.parameters.questionFirstId + '.wav'
          this.question_second_audio = '/audios/' + this.scenario.parameters.questionSecondId + '.wav'
          this.question_second_yes_audio = '/audios/' + this.scenario.parameters.questionSecondYesId + '.wav'
          this.question_second_no_audio = '/audios/' + this.scenario.parameters.questionSecondNoId + '.wav'
        }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка загрузки сценария. ')
        })
      },
      cancel () {
        if (this.$props.campaignid == 0) {
          this.$router.push('/scenarios/')
        } else {
          this.$router.push('/campaigns/' + this.$props.campaignid)
        }
      },
      closeModal () {
        this.showModal = false
        this.currentAudio = null
      },
      openModal (audioId, audioValue, generationType, audioName, isStatic) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий')
        } else {
          this.showModal = true
          this.currentAudio = new FormData()
          this.currentAudio.append('audioId', audioId)
          this.currentAudio.append('audioValue', audioValue)
          this.currentAudio.append('generationType', generationType)
          this.currentAudio.append('audioName', audioName)
          this.currentAudio.append('isStatic', isStatic)
        }
      },
      confirmAction (value) {
        if (this.currentAudio.get('isStatic') == 'true') {
          this.handleUploadRequestStatic(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'))
          // this.$refs['questionPlayer'].load()
        } else {
          this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), value.blob)
          // var key = this.currentAudio.get('audioValue')
          // this.$refs[`audio-${key}`][0].load()
        }
        this.closeModal()
      },
      notSaved () {
        this.isSaved = false
      },
      loadState () {
        this.$http({
          url: PROFILES_API + '/activeState/' + this.loggedId,
          headers: this.prepareSecurityHeader()
        }).then((response) => {
          this.isActive = response.data
          if (!this.isActive) {
            openMessage({
              message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
              type: 'danger',
              showCloseButton: true
            })
          }
        }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].scenarios.errorToGetUserStatus)
        })
      },
      openNotificationWithType (type, message) {
        openNotification({
          title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
          message: message,
          type: type
        })
      },
      clickLoadAudio(parameterkey) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий')
        } else {
          this.$refs['load-audio-' + parameterkey][0].click()
        }
      }
    },
    data () {
      return {
        scenario: {
          template: 'Опрос',
          parameters: {
            questionFirstId:'',
            questionFirstAudio: '',
            questionFirstText: '',
            questionFirstGenerationState: true,

            questionSecondId: '',
            questionSecondAudio: '',
            questionSecondText: '',
            questionSecondGenerationState: true,

            questionSecondYesId: '',
            questionSecondYesAudio: '',
            questionSecondYesText: '',
            questionSecondYesOptional: true,
            questionSecondYesGenerationState: true,

            questionSecondNoId: '',
            questionSecondNoAudio: '',
            questionSecondNoText: '',
            questionSecondNoOptional: true,
            questionSecondNoGenerationState: true,

            dynamicQuestions: [
              {
                generationState: true,
                text: '',
                audio: '',
                id: undefined,
                key: 0
              }
            ]
          },
          checkDuration: true
        },
        tmp: {
          questionFirstGeneratedAudio: '',
          questionFirstLoadedAudio: '',
          questionFirstLoading: false,
          currentSpeakerFirst: 'oksana',
          currentEmotionFirst: 'neutral',
          currentSpeedFirst: 1,

          questionSecondGeneratedAudio: '',
          questionSecondLoadedAudio: '',
          questionSecondLoading: false,
          currentSpeakerSecond: 'oksana',
          currentEmotionSecond: 'neutral',
          currentSpeedSecond: 1,

          questionSecondYesGeneratedAudio: '',
          questionSecondYesLoadedAudio: '',
          questionSecondYesLoading: false,
          currentSpeakerSecondYes: 'oksana',
          currentEmotionSecondYes: 'neutral',
          currentSpeedSecondYes: 1,

          questionSecondNoGeneratedAudio: '',
          questionSecondNoLoadedAudio: '',
          questionSecondNoLoading: false,
          currentSpeakerSecondNo: 'oksana',
          currentEmotionSecondNo: 'neutral',
          currentSpeedSecondNo: 1,

          dynamicTmp: [
            {
              dynamicGeneratedAudio: '',
              dynamicLoadedAudio: '',
              dynamicLoading: false,
              dynamicSpeaker: 'oksana',
              dynamicEmotion: 'neutral',
              dynamicSpeed: 1
            }
          ]
        },
        speakerList: [
          {
            value: 'jane'
          },
          {
            value: 'oksana'
          },
          {
            value: 'alyss '
          },
          {
            value: 'omazh'
          },
          {
            value: 'zahar '
          },
          {
            value: 'ermil '
          }
        ],
        currentEmotion: 'neutral',
        emotionList: [
          {
            value: 'good'
          },
          {
            value: 'neutral'
          },
          {
            value: 'evil'
          }
        ],
        currentSpeed: 1,
        question_first_audio: '',
        question_second_audio: '',
        question_second_yes_audio: '',
        question_second_no_audio: '',
        isSaved: false,
        isActive: false,
        showModal: null,
        title: '',
        currentAudio: null
      }
    },
    created: function () {
      this.loadState()
      if (this.name === undefined) {
        console.log('creating new scenario')
        this.notSaved()
      } else {
        console.log('loading scenario: ' + this.name)
        this.load()
      }
      this.$watch('scenario.parameters.questionFirstAudio', function () {
        this.$refs.onQuestionFirst.load()
      })
      this.$watch('scenario.parameters.questionSecondAudio', function () {
        this.$refs.onQuestionSecond.load()
      })
      this.$watch('scenario.parameters.questionSecondYesAudio', function () {
        this.$refs.onQuestionSecondYes.load()
      })
      this.$watch('scenario.parameters.questionSecondNoAudio', function () {
        this.$refs.onQuestionSecondNo.load()
      })
      // for (let dynamicIndex = 0; dynamicIndex < this.scenario.parameters.dynamicQuestions.length; dynamicIndex++) {
      //  this.$watch('scenario.parameters.dynamicQuestions[dynamicIndex].audio', function () {
      //    const key = scenario.parameters.dynamicQuestions[dynamicIndex].key
      //    this.$refs[`audio-${key}`][0].load()
      //  })
      // }
      if (this.loadedScenario) {
        this.isSaved = true
        if (this.scenario.isReady) {
          this.isReady = this.scenario.isReady
          this.scenario = this.loadedScenario
          this.scenario.isReady = this.isReady
        } else {
          this.scenario = this.loadedScenario
        }
        if (this.scenario.parameters.questionFirstGenerationState) {
          this.tmp.questionFirstGeneratedAudio = this.scenario.parameters.questionFirstAudio
        } else {
          this.tmp.questionFirstLoadedAudio = this.scenario.parameters.questionFirstAudio
        }
        if (this.scenario.parameters.questionSecondGenerationState) {
          this.tmp.questionSecondGeneratedAudio = this.scenario.parameters.questionSecondAudio
        } else {
          this.tmp.questionSecondLoadedAudio = this.scenario.parameters.questionSecondAudio
        }
        if (this.scenario.parameters.questionSecondYesGenerationState) {
          this.tmp.questionSecondYesGeneratedAudio = this.scenario.parameters.questionSecondYesAudio
        } else {
          this.tmp.questionSecondYesLoadedAudio = this.scenario.parameters.questionSecondYesAudio
        }
        if (this.scenario.parameters.questionSecondNoGenerationState) {
          this.tmp.questionSecondNoGeneratedAudio = this.scenario.parameters.questionSecondNoAudio
        } else {
          this.tmp.questionSecondNoLoadedAudio = this.scenario.parameters.questionSecondNoAudio
        }
        for (let dynamicIndex = 0; dynamicIndex < this.scenario.parameters.dynamicQuestions.length; dynamicIndex++) {
          const audio = this.scenario.parameters.dynamicQuestions[dynamicIndex].audio
          if (dynamicIndex != 0) {
            if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
              this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: audio, dynamicLoadedAudio: '', dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 })
            } else {
              this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: '', dynamicLoadedAudio: audio, dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 })
            }
          } else {
            if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
              this.tmp.dynamicTmp[dynamicIndex].dynamicGeneratedAudio = audio
            } else {
              this.tmp.dynamicTmp[dynamicIndex].dynamicLoadedAudio = audio
            }
          }
        }
      }
    },
    beforeUpdate() {
      if (this.loadedScenario) {
        this.isSaved = true
        if (this.scenario.isReady) {
          this.isReady = this.scenario.isReady
          this.scenario = this.loadedScenario
          this.scenario.isReady = this.isReady
        } else {
          this.scenario = this.loadedScenario
        }
        if (this.scenario.parameters.questionFirstGenerationState) {
          this.tmp.questionFirstGeneratedAudio = this.scenario.parameters.questionFirstAudio
        } else {
          this.tmp.questionFirstLoadedAudio = this.scenario.parameters.questionFirstAudio
        }
        if (this.scenario.parameters.questionSecondGenerationState) {
          this.tmp.questionSecondGeneratedAudio = this.scenario.parameters.questionSecondAudio
        } else {
          this.tmp.questionSecondLoadedAudio = this.scenario.parameters.questionSecondAudio
        }
        if (this.scenario.parameters.questionSecondYesGenerationState) {
          this.tmp.questionSecondYesGeneratedAudio = this.scenario.parameters.questionSecondYesAudio
        } else {
          this.tmp.questionSecondYesLoadedAudio = this.scenario.parameters.questionSecondYesAudio
        }
        if (this.scenario.parameters.questionSecondNoGenerationState) {
          this.tmp.questionSecondNoGeneratedAudio = this.scenario.parameters.questionSecondNoAudio
        } else {
          this.tmp.questionSecondNoLoadedAudio = this.scenario.parameters.questionSecondNoAudio
        }
        for (let dynamicIndex = 0; dynamicIndex < this.scenario.parameters.dynamicQuestions.length; dynamicIndex++) {
          const audio = this.scenario.parameters.dynamicQuestions[dynamicIndex].audio
          if (dynamicIndex != 0) {
            if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
              this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: audio, dynamicLoadedAudio: '', dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 })
            } else {
              this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: '', dynamicLoadedAudio: audio, dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 })
            }
          } else {
            if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
              this.tmp.dynamicTmp[dynamicIndex].dynamicGeneratedAudio = audio
            } else {
              this.tmp.dynamicTmp[dynamicIndex].dynamicLoadedAudio = audio
            }
          }
        }
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import 'node_modules/bulma/sass/utilities/mixins';

  .spinner {
    margin-right: 5px;
  }

  .button-center {
    height: 0;
    position: relative;
    top: -4em;
    left: -5.5em;
  }

  .positive-scenario {
    margin-bottom: 10px;
  }

  .add-new {
    border-radius: 100%;
    font-size: 1.3em;
    font-weight: bold;
  }

  .delete-button {
    float: right;
  }

  .add-button-wrapper {
    position: relative;
  }

  p {
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// ScenarioQuestionInterview.vue?c7b923fc